import { useEffect } from 'react';

import Loader from 'components/loader/Loader';
import VirtualizedEntityList from 'containers/pages/sporters/VirtualizedEntityList';
import { useGroupsContext } from 'contexts/GroupsContext';
import GroupsBreadCrumbs from 'containers/partials/misc/GroupsBreadCrumbs';
import usePersonStatus from 'hooks/utils/usePersonStatus';

const SelectPersonsCard = ({
  entityId,
  activeId,
  groupId,
  onClick,
  onBreadcrumbClicked,
  onModal = false,
  extraClassNamesForList = {},
  excludedPersons = [],
  showOnlyGroups = false,
  checkableGroups = false,
  showPersonStatus = true
}) => {
  const {
    state: { group, entities, activeGroupId },
    actions: { getGroups, resetFilter, setActiveGroupId, setFilter },
    loading
  } = useGroupsContext();
  const { personStatusHandler } = usePersonStatus(entityId, groupId);

  useEffect(() => {
    resetFilter();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    getGroups(groupId || entityId);
  }, [entityId, groupId]);

  useEffect(() => {
    if (group?.id) {
      setActiveGroupId(group.id);
    }
  }, [group]);

  const onGroupClickedHandler = async item => {
    await getGroups(item.id);
  };

  const onBreadcrumbClickedHandler = async id => {
    if (onBreadcrumbClicked) {
      onBreadcrumbClicked(id || entityId);
    } else {
      await getGroups(id);
    }
  };

  if (loading || !activeGroupId) return <Loader />;

  return (
    <>
      {activeGroupId !== entityId && (
        <GroupsBreadCrumbs
          entityId={entityId}
          groupId={activeGroupId}
          onClick={id => onBreadcrumbClickedHandler(id)}
        />
      )}

      <VirtualizedEntityList
        id={'persons'}
        onModal={onModal}
        activeId={activeId}
        items={[...entities]}
        checkable
        showPersonStatus={showPersonStatus}
        showOnlyGroups={showOnlyGroups}
        checkableGroups={checkableGroups}
        excludedItems={excludedPersons}
        onClick={(item, type) => {
          if (type === 'group') {
            // setFilter({ search: '' });
            onGroupClickedHandler(item);
          }
          onClick && onClick(item, type);
        }}
        onFilter={setFilter}
        onClickPersonStatus={personStatusHandler}
        extraClassNames={extraClassNamesForList}
      />
    </>
  );
};

export default SelectPersonsCard;
